import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export const useCompressorBasicInformation = function (frameId: string) {
    return useQuery(`${frameId}-basic-information`, () => new Client().compressor_Get(frameId))
};